import { render, staticRenderFns } from "./Rotina.vue?vue&type=template&id=119937d4&scoped=true"
import script from "./Rotina.vue?vue&type=script&lang=js"
export * from "./Rotina.vue?vue&type=script&lang=js"
import style0 from "./Rotina.vue?vue&type=style&index=0&id=119937d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119937d4",
  null
  
)

export default component.exports